// Tiempo que una habitación vendida en línea espera el check in antes de liberarse
export const VENTA_EN_LINEA_DURATION_MS = 5 * 60 * 1000
